/*
 * Hilfsfunktionen für Main.js
 */

import {Trans} from "@lingui/macro";

export function getMattressesByWidth(configuration, mattressesJson) {
    // Matratzen-Objekt nach Breite filtern
    let mattressesFiltered = {}
    let mattressWidth = parseInt(configuration.width)
    if ( (configuration.frameQuantity === 2) && (configuration.mattressQuantity === 1) ) {
        mattressWidth *= 2
    }
    for (const id in mattressesJson) {
        if (mattressesJson[id].width === mattressWidth) {
            mattressesFiltered[id] = mattressesJson[id]
        }
    }
    for (const [key, val] of Object.entries(mattressesFiltered)) {
        let
            height = '',
            hardness = '';
        if (val.height) {
            height = <><Trans>Höhe</Trans>: {val.height}</>
        }
        if (val.hardness) {
            if (val.height) {
                hardness = <>, <Trans>Härte</Trans>: {val.hardness}</>
            } else {
                hardness = <><Trans>Härte</Trans>: {val.hardness}</>
            }
        }
        Object.assign(
            val,
            {
                name: val.nameRaw + ', ' + val.width + ' cm',
                more: <>{height}{hardness}</>,
                badges: val.badges
            }
        )
    }
    return mattressesFiltered;
}

export function getToppersByWidth(configuration, toppersJson) {
    // Topper-Objekt nach Breite filtern
    let toppersFiltered = {}
    let topperWidth = parseInt(configuration.width)
    if ( (configuration.frameQuantity === 2) && (configuration.topperQuantity === 1) ) {
        topperWidth *= 2
    }
    for (const id in toppersJson) {
        if (toppersJson[id].width === topperWidth) {
            toppersFiltered[id] = toppersJson[id]
        }
    }
    for (const [key, val] of Object.entries(toppersFiltered)) {
        let more = ''
        if (val.height !== '0') {
            more = <><Trans>Höhe</Trans>: {val.height}</>
        }
        Object.assign(
            val,
            {
                name: val.nameRaw + ', ' + val.width + ' cm',
                more: <>{more}</>
            }
        )
    }
    return toppersFiltered
}

export function getSuitableFeet(configuration, feet, selected) {
    // Fußsets filtern (manche breite Betten erfordern 5 statt 4 Füße)
    let ret = feet
    for (const [i, foot] of Object.entries(ret)) {
        for (const [j, variant] of Object.entries(foot.variants)) {
            {
                if ( !selected || !selected['5feetFrom'] || (configuration.width < parseInt(selected['5feetFrom'])) ) {
                    if (+ret[i].variants[j].feet + +ret[i].variants[j].wheels > 4) {
                        delete (ret[i].variants[j])
                    }
                } else {
                    if (+ret[i].variants[j].feet + +ret[i].variants[j].wheels <= 4) {
                        delete (ret[i].variants[j])
                    }
                }
            }
        }
    }
    return ret
}